import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import {
  formatTextFloat,
  formatValue,
  formatVolume,
} from '../../../helpers/Text';
import BuySellTreeMap from '../common/buy-sell-tree-map/BuySellTreeMap';
import Tooltip from '../common/buy-sell-tree-map/Tooltip';
import Const from '../Const';
import Filter from './Filter';
import { fetchProprietary, REDUCER_NAME } from '../reducer';
import withRealTime from '../withRealTime';
import Footer from './../../../common/table/Footer';

const renderBuyTooltip = (data, textClassName, currentType) => {
  let thirdTitle = 'moneyFlowProprietary.tooltipBuyVolumeTitle';
  let thirdValue = formatTextFloat(formatVolume(data.totalBuyTradeVolume));
  if (currentType === 'NET_VALUE') {
    thirdTitle = 'moneyFlowProprietary.tooltipBuyNetTitle';
    thirdValue = formatTextFloat(
      formatValue(Math.abs(data.totalNetBuyTradeValue)),
    );
  }

  return (
    <Tooltip
      textClassName={textClassName}
      data={data}
      secondTitle="moneyFlowProprietary.tooltipBuyTitle"
      secondValue={data.totalBuyTradeValue}
      thirdTitle={thirdTitle}
      thirdValue={thirdValue}
    />
  );
};

const renderSellTooltip = (data, textClassName, currentType) => {
  let thirdTitle = 'moneyFlowProprietary.tooltipSellVolumeTitle';
  let thirdValue = formatTextFloat(formatVolume(data.totalSellTradeVolume));
  if (currentType === 'NET_VALUE') {
    thirdTitle = 'moneyFlowProprietary.tooltipSellNetTitle';
    thirdValue = formatTextFloat(
      formatValue(Math.abs(data.totalNetSellTradeValue)),
    );
  }
  return (
    <Tooltip
      textClassName={textClassName}
      data={data}
      secondTitle="moneyFlowProprietary.tooltipSellTitle"
      thirdTitle={thirdTitle}
      secondValue={data.totalSellTradeValue}
      thirdValue={thirdValue}
    />
  );
};

const Proprietary = ({ proprietary, isLoading }) => {
  return (
    <div className="tab-pane active d-flex flex-column flex-fill">
      <div className="mb-10 pl-20 pr-20">
        <Filter />
      </div>

      <div className="pl-20 pr-20 d-flex flex-fill flex-column h-100">
        <BuySellTreeMap
          isTicker={false}
          netBuyKey="totalNetBuyTradeValue"
          netSellKey="totalNetSellTradeValue"
          dropdown={{
            ids: Const.proprietaryDropDown,
            data: Const.proprietaryDropDownData,
          }}
          renderBuyTooltip={renderBuyTooltip}
          renderSellTooltip={renderSellTooltip}
          isLoading={isLoading}
          data={proprietary}
        />

        <Footer
          listTextLang={[
            {
              text: 'moneyFlowProprietary.footerText',
            },
          ]}
        />
      </div>
    </div>
  );
};

Proprietary.propTypes = {
  proprietary: PropTypes.object.isRequired,
  fetchData: PropTypes.func.isRequired,
  comGroupCode: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  proprietary: state[REDUCER_NAME].proprietary.data,
  isLoading: state[REDUCER_NAME].proprietary.isLoading,
  comGroupCode: state[REDUCER_NAME].proprietary.comGroupCode,
});

const mapDispatchToProps = {
  fetchData: fetchProprietary,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRealTime(Proprietary));
